// @flow
import * as React from 'react';
import PropTypes from 'prop-types';

import {Divider, makeStyles, Typography} from '@material-ui/core';
import CustomButton from '../../../elements/CustomButton/CustomButton';
import {CheckCircleRounded, RadioButtonUnchecked} from '@material-ui/icons';
import {colors} from '../../../assets/styles/colors';

type Props = {|
  title?: string,
  completed?: boolean, // startIcon
  children?: React.Node, // children
  onDoneButtonClick?: () => void,
|};

export const useStyles = makeStyles(theme => ({
  root: {
    borderRadius: '12px',
    boxShadow:
      '0px 0px 1px rgba(181, 181, 181, 0.2), 0px 2px 8px rgba(209, 209, 209, 0.16)',
    backgroundColor: 'white',
    padding: theme.spacing(2, 3),
    width: 320,
    height: 730,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    marginRight: theme.spacing(4),
    [theme.breakpoints.down('sm')]: {
      margin: theme.spacing(0, 0, 4, 0),
      maxWidth: '100%',
    },
  },
  checkbox: {
    marginLeft: 'auto',
    fontSize: '2rem',
  },
  checkedCheckbox: {
    color: colors.success,
  },
  title: {
    marginBottom: theme.spacing(2),
    fontWeight: 600,
    fontSize: '1.5rem',
    color: colors.grey900,
  },
  divider: {
    background: colors.grey200,
    width: '100%',
    // margin: theme.spacing(0, 3),
  },
  footer: {
    marginTop: 'auto',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  doneButton: {
    marginTop: theme.spacing(2),
    width: 200,
    height: 36,
    fontWeight: 600,
    fontSize: '1.125rem',
  },
}));

export default function ShareSocialsCard(props: Props) {
  const {title, completed, children, onDoneButtonClick} = props;
  const classes = useStyles();

  const checkedCheckbox = (
    <CheckCircleRounded
      className={`${classes.checkbox} ${classes.checkedCheckbox}`}
    />
  );
  const uncheckedCheckbox = (
    <RadioButtonUnchecked className={classes.checkbox} />
  );

  return (
    <div className={classes.root}>
      {completed ? checkedCheckbox : uncheckedCheckbox}
      <Typography className={`${classes.title}`}>{title}</Typography>
      <Divider className={classes.divider} />
      {children}
      <div className={classes.footer}>
        <Divider className={classes.divider} />
        <CustomButton
          variant="contained"
          color="primary"
          className={classes.doneButton}
          onClick={onDoneButtonClick}
        >
          Hecho
        </CustomButton>
      </div>
    </div>
  );
}

ShareSocialsCard.propTypes = {
  title: PropTypes.string,
  completed: PropTypes.bool,
  children: PropTypes.node,
  onDoneButtonClick: PropTypes.func.isRequired,
};
